/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { Menu } from 'semantic-ui-react';
import { getPlatforms, getCatalogPlatform } from 'catalog/reducers/platforms';
import PlatformSelector
  from 'catalog/screens/shared/components/PlatformSelector';
import * as PlatformActions from 'catalog/actions/platforms';

type Props = {
  platform: CatalogPlatform,
  platforms: Array<CatalogPlatform>,
  changePlatform: (platform: CatalogPlatform) => void,
};

const mapStateToProps = state => ({
  platform: getCatalogPlatform(state),
  platforms: getPlatforms(state),
});

const CatalogMenu = ({ platform, platforms, changePlatform }: Props) => (
  <Menu.Menu position="right">
    <Menu.Item>
      <PlatformSelector
        value={platform}
        platforms={platforms}
        onChange={changePlatform}
      />
    </Menu.Item>
  </Menu.Menu>
);

export default connect(mapStateToProps, {
  changePlatform: PlatformActions.changeCatalogPlatform,
})(CatalogMenu);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Catalog/Menu.js